import React from 'react'
import TableHeadings from '../../components/Common-components/table-headings'
import { Pagination } from '../../components/Pagination'
import DateInput from '../../components/DateInput/index'
import FilterListIcon from '@mui/icons-material/FilterList'
import SearchFilter from '../../components/Common-components/serchFillter'
import { useTranslation } from 'react-i18next'
import moment from 'moment-timezone'
import { Spinner } from '../../components/Common-components/spinner'
import useTickets from './hook/useTickets'
import Modal from '../../components/PopUpModal'
import { Avatar } from '@mui/material'
import { imageBaseUrl, imageSize, Validation } from '../../components/Constant'
import { MdOutlineCalendarToday, MdOutlineLocationOn, MdOutlineCategory } from 'react-icons/md'
import { LiaAddressCardSolid } from 'react-icons/lia'
import { LuUser } from 'react-icons/lu'
import useLanguage from '../../hooks/useLanguage'
const Ticketbooking = () => {
  const { t } = useTranslation()
  const {isEngLang} = useLanguage()
  const {
    TableHeaderData,
    totalCount,
    controller,
    bookingList,
    filtermodal,
    Filter,
    loader,
    openModal,
    handleOpenModal,
    handleClosedModal,
    handlePagination,
    handleClickFilter,
    handleChangeFilter,
    HandleSearch,
    reset,
  } = useTickets()
  const evenfoInfo = {
    ...openModal?.data,
    ticketBuyDetails: openModal?.data?.ticketBuyDetails?.map((ticket) => {
      const matchedEvent = openModal?.data?.eventInfo?.find((event) => event?._id === ticket?.ticketId)
      return {
        ...ticket,
        price: matchedEvent?.price ?? ticket.price,
      }
    }),
  }

  const eventDetails = evenfoInfo || {}

  return (
    <>
      {loader && <Spinner />}
      <div className=" d-flex flex-column justify-content-between flex-fill h-100">
        <div className="">
          <div className=" d-flex align-items-center">
            <div className="d-flex flex-fill justify-content-between position-relative">
              <SearchFilter disabled={Filter?.disable_button} handleSearch={HandleSearch} handleFilterInput={handleChangeFilter} value={Filter?.search} reset={reset} />
              <button className="btn filter_Btn me-1" onClick={handleClickFilter}>
                <FilterListIcon className="font-19" titleAccess={`${t('filterTitle.filter')}`} /> {`${t('filterTitle.filter')}`}
              </button>

              {filtermodal?.open && (
                <div className="show_filter_popup">
                  <h2 className="m-0 font-16 black-color ">{`${t('filterTitle.filter')}`}</h2>
                  <hr className="my-1 black-color" />
                  <div className="row px-3 py-3">
                    <div className=" col-md-4 col-sm-6  col-12">
                      <DateInput
                        size="small"
                        variant="outlined"
                        className=" form-field-design w-100 fullWidth"
                        Label={`${t('formTitle.startDate')}`}
                        SelectedDate={Filter?.startDate || null}
                        handleDateChange={(date) => handleChangeFilter({ target: { name: 'startDate', value: date } })}
                      />
                    </div>
                    <div className=" col-md-4 col-sm-6  col-12">
                      <DateInput
                        size="small"
                        variant="outlined"
                        className=" form-field-design w-100 fullWidth"
                        Label={`${t('formTitle.endDate')}`}
                        SelectedDate={Filter?.endDate || null}
                        handleDateChange={(date) => handleChangeFilter({ target: { name: 'endDate', value: date } })}
                      />
                    </div>
                    <div className="d-flex justify-content-end pt-3 col-12">
                      <button
                        className=" custom_button outline_button blue-color font-14 px-5 py-2 ms-3"
                        onClick={() => {
                          reset({ filterPopup: true })
                        }}
                      >{`${t('buttonTitle.reset')}`}</button>
                      <button className="custom_button bg-blue-color2 white-color font-14 px-5 py-2 ms-3" onClick={() => HandleSearch({ filterPopup: true })}>{`${t('buttonTitle.apply')}`}</button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="table-responsive custom_table  flex-fill mt-3 custom_scroll">
          <table className="table cus-table">
            <TableHeadings TableHeadData={TableHeaderData} />
            <tbody>
              {bookingList?.map((cur, index) => (
                <tr key={cur.id || index}>
                  <td>{controller?.rowsPerPage * (controller?.page - 1) + index + 1}</td>
                  <td onClick={() => handleOpenModal('view', cur)} className="blue-color cursor">
                    {cur?.bookingReferenceNumber}
                  </td>
                  <td>{isEngLang ? cur?.eventName : cur?.eventName_ar}</td>
                  <td>{cur?.clientName}</td>
                  {/* <td>{cur?.quantity}</td> */}
                  <td>{moment(cur?.dateOfEvents).format('lll')}</td>
                  <td>{cur?.finalTotal?.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div>{totalCount > 10 && <Pagination count={totalCount} controller={controller} setController={handlePagination} />}</div>
      </div>
      <Modal
        className="p-0"
        size="xl"
        onHide={() => handleClosedModal('view')}
        show={openModal?.view}
        headerContent={
          <h5 className="m-0 ms-3 py-3 black-color fw-6 font-20 text-start w-100">
            {t('formTitle.event')} {t('boxTitle.ticketDetails')}
          </h5>
        }
        bodyContent={
          <div>
            <div className="event_ticket_details_container">
              {/* Event Header Section */}
              <div className="event_ticket_details_header_section">
                <div className="d-flex align-items-start">
                  {/* Left side - Avatar and basic info */}
                  <div className="event_ticket_details_left_section">
                    <Avatar
                      alt="RCB"
                      src={
                        eventDetails?.images?.[0]?.match(Validation?.pattern?.isValidVideo)
                          ? `${imageBaseUrl}vendorServiceImg/${eventDetails?.images?.[0]}.png`
                          : `${imageBaseUrl}vendorServiceImg/${imageSize}/${eventDetails?.images?.[0]}`
                      }
                      sx={{ width: 56, height: 56 }}
                    />
                    <div className="event_ticket_details_event_info">
                      <h4 className="event_ticket_details_event_name">{isEngLang ? eventDetails?.eventName : eventDetails?.eventName_ar ?? '-'}</h4>
                      <div className="event_ticket_details_datetime">
                        <MdOutlineCalendarToday size={18} />
                        <span>{moment(eventDetails?.dateOfEvents).format('MMM DD, YYYY, hh:mm A')}</span>
                      </div>
                      <div className="event_ticket_details_reference">
                        <LiaAddressCardSolid size={18} />
                        <span>Ref: {eventDetails?.bookingReferenceNumber}</span>
                      </div>
                    </div>
                  </div>

                  {/* Right side - Status and location */}
                  <div className="event_ticket_details_right_section">
                    <div className="event_ticket_details_location">
                      <MdOutlineLocationOn size={18} />
                      <span>{eventDetails?.venue ?? '-'}</span>
                    </div>
                    <div className="event_ticket_details_category">
                      <MdOutlineCategory size={18} />
                      <span>
                        {t('tableTitle.category')}: {isEngLang ? eventDetails?.subCategory : eventDetails?.subCategory_ar}
                      </span>
                    </div>
                    <div className="event_ticket_details_category">
                      <LuUser size={18} />
                      <span>
                        {t('tableTitle.clientName')}: {eventDetails?.clientName}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table Section */}
              <div className="event_ticket_details_table_section">
                <table className="event_ticket_details_table">
                  <thead>
                    <tr className="event_ticket_details_table_head">
                      <th>{t('tableTitle.ticketType')}</th>
                      <th>
                        {t('formTitle.price')} ({t('tableTitle.currencysymbols')})
                      </th>
                      {/* <th>Available</th>
                                            <th>Booked</th> */}
                      <th>{t('tableTitle.gates')} </th>
                      {/* <th>Status</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {eventDetails?.ticketBuyDetails?.map((ticket, index) => {
                      return (
                        <tr className="event_ticket_details_table_row">
                          <td>
                            <div className="event_ticket_details_ticket_type">
                              <div className="event_ticket_details_type_name">{ticket?.ticketType ?? '-'}</div>
                              {/* <div className="event_ticket_details_redeem_text">Redeem: {ticket?.redeemQuantity ?? "-"} per booking</div> */}
                            </div>
                          </td>
                          <td>
                            <div className="event_ticket_details_price">{ticket?.price ?? '-'}</div>
                          </td>
                          {/* <td>
<div className="event_ticket_details_available">
<div className="event_ticket_details_number">14</div>
<div className="event_ticket_details_label">total</div>
</div>
</td> */}
                          {/* <td>
<div className="event_ticket_details_booked">
<div className="event_ticket_details_booked_number">11</div>
<div className="event_ticket_details_label">3 left</div>
</div>
</td> */}
                          <td>
                            <div className="event_ticket_details_gates">
                              {ticket?.name?.map((cur) => {
                                return <span className="event_ticket_details_gate">{cur?.levelName}</span>
                              })}
                            </div>
                          </td>
                          {/* <td>
                                                        <span className="event_ticket_details_status">Available</span>
                                                    </td> */}
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>

              {/* Summary Footer */}
              <div className="event_ticket_details_summary">
                <div className="row g-0">
                  {/* <div className="col-6">
                                        <div className="event_ticket_details_summary_item">
                                            <div className="event_ticket_details_summary_title">Total Redeemed</div>
                                            <div className="event_ticket_details_summary_value">{totalReedmed}</div>
                                        </div>
                                    </div> */}
                  <div className="col-12 d-flex justify-content-end">
                    <div className="event_ticket_details_summary_item ">
                      <div className="event_ticket_details_summary_title">
                        {t('tableTitle.totalPrice')} ({t('tableTitle.currencysymbols')})
                      </div>
                      <div className="event_ticket_details_summary_value">{eventDetails?.finalTotal?.toFixed(2)}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      />
    </>
  )
}

export default Ticketbooking
